import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import AuthorsList from './AuthorsList';
import LoadingCard from '../LoadingCard';
import Notification from '../Notification';
import Card from '../Card/Card';
import Icon from '../Icon/Icon';
import BasicLink from '../BasicLink';
import { getAuthors } from '../../actions/authors';
import { getFollowing } from '../../actions/follow';

const isFetching = state => state && state.fetching;
const isErrorWithTimeout = state => (state && state.error && state.timeout);

const fetchAuthors = (props, retryTimeout) => {
  const {
    doc,
    authors,
  } = props;

  if (!doc.id || !doc.authors || !doc.authors.length || isFetching(authors)) {
    return;
  }

  if (!authors || (isErrorWithTimeout(authors) && retryTimeout)) {
    props.getAuthors({ documentId: doc.id });
  }
};

const fetchFollowing = (props, retryTimeout) => {
  const { following, currentUser } = props;

  if (!currentUser || isFetching(following)) return;

  if (!following.users || (isErrorWithTimeout(following) && retryTimeout)) {
    props.getFollowing(currentUser);
  }
};

const ShowAll = ({ url, track }) => (
  <div className="text-right button-group">
    <BasicLink
      data-name="see-all"
      to={`${url}authors`}
      withIcon
      track={{ ...track, value: { origin: 'AuthorsCard' }, action: 'OpenAuthors' }}
    >
      <span>See all authors</span>
      <Icon name="navigateright" />
    </BasicLink>
  </div>
);

class AuthorsListContainer extends Component {
  componentWillMount() {
    fetchAuthors(this.props, process.browser);
    fetchFollowing(this.props, process.browser);
  }

  render() {
    const {
      doc,
      authors,
      track,
      title,
      withColumns,
      max,
      match,
      following,
    } = this.props;

    if (!doc.authors || !doc.authors.length) {
      return (
        <Notification type="info" data-name="document-authors-no-authors">
          There are no authors.
        </Notification>
      );
    }

    if (!authors || authors.fetching) {
      return <LoadingCard title={title} />;
    }

    if (authors.error && !authors.error.timeout) {
      return (
        <Card title={title}>
          <Notification type="error" data-name="document-authors-error">
            Error loading document authors.
          </Notification>
        </Card>
      );
    }

    const visibleAuthors = max
      ? authors.slice(0, max)
      : authors;

    return (
      <Card title={title} data-name="authors-card">
        <AuthorsList
          authors={visibleAuthors}
          following={following.users}
          track={track}
          withColumns={withColumns}
        />
        { authors.length > max && <ShowAll url={match.url} track={track} /> }
      </Card>
    );
  }
}

const mapStateToProps = (state, props) => ({
  authors: state.authors[props.doc.id],
  following: state.following,
  currentUser: state.session.user,
});

const mapDispatchToProps = {
  getAuthors,
  getFollowing,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AuthorsListContainer));



// WEBPACK FOOTER //
// ./src/universal/ui/components/AuthorsList/AuthorsListContainer.js